"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = findAllAssetIds;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof")),
    _lodash = _interopRequireDefault(require("lodash.uniq")),
    ASSET_KEY = "assetId",
    ASSETS_KEY = "assetIds";

function isObject(value) {
  return !!(value && "object" === (0, _typeof2["default"])(value));
}

function findAssetIds(data) {
  return isObject(data) ? Array.isArray(data) ? data.reduce(function (assetIds, dataValue) {
    return [].concat((0, _toConsumableArray2["default"])(assetIds), (0, _toConsumableArray2["default"])(findAssetIds(dataValue)));
  }, []) : Object.keys(data).reduce(function (assetIds, key) {
    var dataValue = data[key];
    if (!dataValue) return assetIds;

    if (key === ASSET_KEY || key === ASSETS_KEY) {
      var args = Array.isArray(dataValue) ? dataValue : [dataValue];
      return [].concat((0, _toConsumableArray2["default"])(assetIds), (0, _toConsumableArray2["default"])(args));
    }

    return isObject(dataValue) ? [].concat((0, _toConsumableArray2["default"])(assetIds), (0, _toConsumableArray2["default"])(findAssetIds(dataValue))) : assetIds;
  }, []) : [];
}

function findAllAssetIds(data, callback) {
  if (isObject(data)) {
    var assetIds = findAssetIds(data);
    assetIds.length && callback((0, _lodash["default"])(assetIds));
  }
}